module.exports = __webpack_public_path__ + "static/forecast/weather/nightpartcloud-a8c721ce7053de280e782e4c6e89ecfa.svg";